import React from 'react';
import { Pill } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { TabBtn } from '../../shared/ui/tab-btn';

export const PillButton: React.FC = () => {
  const { addPill } = useEditorCanvas();
  return <TabBtn onClick={addPill} label='Pill' icon={<Pill size={18} />} />;
};
